import React, { useState, useContext, useEffect, useRef, forwardRef, useImperativeHandle, Children } from 'react';
import Button from '@mui/material/Button';
import {

    Box,
    Grid2 as Grid,
    DialogTitle,

} from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';



import { Edit, RemoveCircle, Save, Search } from '@mui/icons-material';







export const MatchDynamicSourceDialog = ({ MyContent, title, button_label, handleSave }) => {

    const [open, setOpen] = useState(false);
 


    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };






    return (
        <div>

            <Button variant="contained" color="primary" size="small" onClick={handleOpen} startIcon={<Edit />}>{button_label}</Button>
            <Dialog open={open} onClose={handleClose} fullWidth={true} maxWidth="md">
                <DialogTitle>
                    {title}
                </DialogTitle>
                <DialogContent>
                    <MyContent />
                </DialogContent>
                <DialogActions>
                    <Button variant="contained" key={'bc'} onClick={handleClose}>OK</Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}

